export var FlagFrom;
(function (FlagFrom) {
    FlagFrom["Read"] = "Read";
    FlagFrom["Write"] = "Write";
    FlagFrom["Visible"] = "Visible";
})(FlagFrom || (FlagFrom = {}));
